module.exports = __webpack_public_path__ + "static/chris-testimonial-99809a53184b4570630f22925a1eda22.png";